import { PermissionObjectType } from '@/interfaces/permissionObjectType';
import { PermissionResource, permissionResource } from '@/resources/permission.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł uprawnień
 *
 * @export
 * @class PermissionModule
 * @extends {EntityModule<PermissionObjectType, PermissionResource>}
 */
export class PermissionModule extends EntityModule<PermissionObjectType, PermissionResource> {
  constructor() {
    super(permissionResource);
  }
}

export default new PermissionModule();
